import React from "react";
import styled from "styled-components";

const Wrapper = styled.div`
  display: flex;
  padding: ${(props) => (props.padding ? props.padding : "24px")};
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  border-radius: 8px;
  background: ${(props) => props.bg || "#fff"};
  width: 100%;
  border: ${(props) => (props.border ? props.border : "none")};

  .headerText {
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
    color: ${(props) => props.headerColor || "#07070c"};
  }
`;

const CardFrame = ({
  headerText,
  children,
  bg,
  headerColor,
  className,
  onClick,
  actionBtn,
  padding,
  border,
}) => {
  return (
    <Wrapper
      bg={bg}
      headerColor={headerColor}
      className={className}
      padding={padding}
      border={border}
    >
      <div className="fullWidth flexRow alignCenter justifySpaceBetween header">
        <div className="headerText">{headerText}</div>
        <div
          className="colorSecondary l3 cursorPointer"
          onClick={(e) => {
            e.stopPropagation();
            onClick && onClick();
          }}
        >
          {actionBtn}
        </div>
      </div>
      {children}
    </Wrapper>
  );
};

export default CardFrame;
